import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner, Center, Text, VStack } from '@chakra-ui/react';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'organizer' | 'viewer';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole 
}) => {
  const { user, isLoading, isAuthenticated } = useAuth();

  console.log('ProtectedRoute check:', { 
    isLoading, 
    isAuthenticated, 
    userEmail: user?.email,
    requiredRole,
    currentPath: window.location.pathname
  });

  if (isLoading) {
    console.log('ProtectedRoute: Still loading...');
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="blue.500" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    console.log('ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Check role permissions if required
  if (requiredRole && user) {
    const roleHierarchy = {
      'viewer': 1,
      'organizer': 2,
      'admin': 3
    };

    const userLevel = roleHierarchy[user.role as keyof typeof roleHierarchy] || 0;
    const requiredLevel = roleHierarchy[requiredRole] || 999;

    if (userLevel < requiredLevel) {
      console.log('ProtectedRoute: Insufficient permissions');
      return (
        <Center minH="100vh">
          <VStack spacing={4} textAlign="center">
            <Text fontSize="2xl" color="red.500">
              Accès refusé
            </Text>
            <Text color="gray.600">
              Vous n'avez pas les permissions nécessaires pour accéder à cette page.
            </Text>
            <Text fontSize="sm" color="gray.500">
              Rôle requis: {requiredRole} | Votre rôle: {user.role}
            </Text>
          </VStack>
        </Center>
      );
    }
  }

  console.log('ProtectedRoute: Access granted');
  return <>{children}</>;
};